import React from "react";
import {FunctionalModal} from "./FunctionalModal";

const InformationalModal = ({component, setOpen}) => {
    return <FunctionalModal component={component} setOpen={setOpen}/>
}

export default InformationalModal